import { FormArray, UntypedFormGroup } from '@angular/forms';
import { ObjectWithProps } from '@ip-only/front-end-library';
import {
  BasicSectionData,
  ComissionV2Request,
  InstallationReportRequestV2,
  InstallationReportTabNames,
  MeasuringV2Request,
  PreInstallationV2Request,
} from '../installation-report-content-entities';

const getFormValueBasedOnType = (
  reportForm: UntypedFormGroup,
  type: InstallationReportTabNames,
) => {
  return (reportForm.get(type) as FormArray).value as ObjectWithProps;
};

export const updateInstallationReportRequestBody = (
  reportForm: UntypedFormGroup,
  deliveryOrderId: string,
): InstallationReportRequestV2 => {
  return {
    deliveryOrderId: deliveryOrderId,
    plotDesign: getBasicSectionFormData(
      getFormValueBasedOnType(
        reportForm,
        InstallationReportTabNames.PLOT_DESIGN,
      ) as BasicSectionData,
    ),
    plotExcavation: getBasicSectionFormData(
      getFormValueBasedOnType(
        reportForm,
        InstallationReportTabNames.PLOT_EXCAVATION,
      ) as BasicSectionData,
    ),
    ductConnecting: getBasicSectionFormData(
      getFormValueBasedOnType(
        reportForm,
        InstallationReportTabNames.DUCT_CONNECTION,
      ) as BasicSectionData,
    ),
    preInstallation: getPreInstallationFormData(
      getFormValueBasedOnType(
        reportForm,
        InstallationReportTabNames.PRE_INSTALLATION,
      ) as PreInstallationV2Request,
    ),
    measuring: getSplicingAndMeasuringFormData(
      getFormValueBasedOnType(
        reportForm,
        InstallationReportTabNames.SPLICING_MEASURING,
      ) as MeasuringV2Request,
    ),
    commission: getCommissionFormData(
      getFormValueBasedOnType(
        reportForm,
        InstallationReportTabNames.COMMISSIONING,
      ) as ComissionV2Request,
    ),
    cableBlowing: getBasicSectionFormData(
      getFormValueBasedOnType(
        reportForm,
        InstallationReportTabNames.CABLE_BLOWING,
      ) as BasicSectionData,
    ),
  };
};

const getBasicSectionFormData = (data: BasicSectionData): BasicSectionData => {
  return {
    status: data.status,
    comment: data.comment,
    plannedDate: data.plannedDate,
    completedDate: data.completedDate,
  };
};

const getPreInstallationFormData = (
  data: PreInstallationV2Request,
): PreInstallationV2Request => {
  return {
    status: data.status,
    comment: data.comment,
    plannedDate: data.plannedDate,
    completedDate: data.completedDate,
    macAddress: data.macAddress,
  };
};

const getSplicingAndMeasuringFormData = (data: MeasuringV2Request) => {
  return {
    comment: data.comment,
    plannedDate: data.plannedDate,
    completedDate: data.completedDate,
    status: data.status,
    usesPanelCard: data.usesPanelCard,
    switchName: data.switchName,
    switchPort: data.switchPort,
    switchCard: data.switchCard,
    odfInSite: data.odfInSite,
    odfContact: data.odfContact,
    cabinet: data.cabinet,
    cableIdCabinet: data.cableIdCabinet,
    fiberInCabinet: data.fiberInCabinet,
    ductColorInCabinet: data.ductColorInCabinet,
    fos: data.fos,
    cableId: data.cableId,
    fiberNumber: data.fiberNumber,
    subDuctColor: data.subDuctColor,
    hasSplicingFiberOutletImage: data.hasSplicingFiberOutletImage,
    hasSplicingFosImage: data.hasSplicingFosImage,
    hasSealingDuctInFosImage: data.hasSealingDuctInFosImage,
    hasOdfPortImage: data.hasOdfPortImage,
    splitterName: data.splitterName,
    splitterPort: data.splitterPort,
  };
};

const getCommissionFormData = (
  data: ComissionV2Request,
): ComissionV2Request => {
  return {
    status: data.status,
    comment: data.comment,
    plannedDate: data.plannedDate,
    completedDate: data.completedDate,
    attachments: data.attachments,
    hasNodeImage: data.hasNodeImage,
    hasOdfPortImage: data.hasOdfPortImage,
    hasSwitchPortImage: data.hasSwitchPortImage,
    odfContactPort: data.odfContactPort,
    odfPanel: data.odfPanel,
    switchCard: data.switchCard,
    switchName: data.switchName,
    switchPort: data.switchPort,
    usesPanelCard: data.usesPanelCard,
  };
};
